module.exports = __webpack_public_path__ + "assets/img/18_187_big.a82b05dc.jpg";